import PropTypes from 'prop-types';

export const ExternalDownloadPropTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  file: PropTypes.string.isRequired,
};

export default PropTypes.shape(ExternalDownloadPropTypes);



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalDownloadShape.js